import { defineSagaForService } from '@repo/core'
import { createFundScreenerSession } from '@repo/tools-services'
import { fundScreenerSessionDataActions } from '../../../store/actions'

export const fundScreenerSessionServiceConfig = defineSagaForService({
  [fundScreenerSessionDataActions.postRequest.type]: {
    apiClientDomain: 'tools',
    service: createFundScreenerSession,
    actionTypeResponse: fundScreenerSessionDataActions.postResponse.type,
    actionTypeRequest: fundScreenerSessionDataActions.postRequest.type,
  },
})
